//  Copyright (c) 2020 Comsearch, Inc., All rights reserved

import {
  INVALID_EXTENDED_NUMBER_RANGE_FORMAT,
  REQUIRED,
} from 'errors'

// v is a string which must match the extended number range format

// TODO - it might make sense to create a 'validateExtendedNumberRangeFormat'
// and have validateExtendedNumberRange actually support the range of acceptable values
// this could also reuse the logic in validateNumberRange as long as it was refactored to
// support the logic short cutting that's used in validation rules here.

const validateExtendedNumberRange = (v, required = false) => {
  if (!required && !v) {
    return false
  } else if (required && !v) {
    return REQUIRED
  }

  return (
    (
      // makes sure that the value can only contain numbers, colons, commas, spaces and newline characters
      v.match(/^[\d:,\s\n]+$/) === null ||
      // makes sure first character is a digit
      v[0].match(/\d/) === null ||
      // makes sure the last character is a digit
      v[v.length - 1].match(/\d/) === null ||
      // ensures that each comma spaced value is either a number or a number range like 1:4
      // also allows for weird spacing use since this is a text area and user might use
      // space/newline to separate groups
      v.split(',').every(d => d.trim().match(/^\s?(\d+|\d+\s?:\s?\d+)\s?$/) === null)
    ) && INVALID_EXTENDED_NUMBER_RANGE_FORMAT
  )
}

export default validateExtendedNumberRange
